import { memo } from "react";
import { useUsers } from "modules/providers/users-provider";
import { isUserInteractive } from "modules/utils/Functions";
import { CALLOUT_KEY } from "modules/utils/Constants";

interface IProps {
  userId: string;
}

const UserCallout = ({ userId }: IProps) => {
  const { usersById } = useUsers();
  const user = usersById[userId];

  if (!user) return null;
  if (!isUserInteractive(user)) return null;

  return `${CALLOUT_KEY}${user.callout}`;
};

export default memo(UserCallout);
